import(/* webpackMode: "eager", webpackExports: ["HomeComponent"] */ "/home/ubuntu/stock-backend/apps/front/app/home/home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/home/ubuntu/stock-backend/apps/front/components/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootHeader"] */ "/home/ubuntu/stock-backend/apps/front/components/root-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeWrapper"] */ "/home/ubuntu/stock-backend/apps/front/components/theme-wrapper.tsx");
